import { useSearchMenuContext } from "../search-menu.context";
import styles from "../search-menu.module.scss";
import type { SearchMenuEmptyProps } from "../types-search-menu";

/** Estado vazio: só aparece quando a busca não deixa nenhum item. */
export function SearchMenuEmpty({ className, children, ...rest }: SearchMenuEmptyProps) {
  const { hasResults } = useSearchMenuContext();
  if (hasResults) return null;

  return (
    <li className={[styles.empty, className].filter(Boolean).join(" ")} {...rest} role="none">
      {children}
    </li>
  );
}
SearchMenuEmpty.displayName = "SearchMenu.Empty";
